import React from 'react';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import { SpacingStack } from '@components/SpacingStack';
import {
  ColumnWrapper,
  Container,
  StyledGetStartedButton,
  TextPairingWrapper,
  StyledConnectedGuestList,
} from './ConnectedGuestListSection.styles';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { CTALink } from '@components/CTALink';
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from 'react-i18next';

export const ConnectedGuestListStatic: React.FC = () => {
  const { t } = useTranslation('onlineRsvp');
  const { eyebrow, title, getStarted, learnMore, image } = t('connectedGuestList');

  return (
    <Container as={'section'} paddingTop={[12]} id="RSVP_Guest_List_Cross">
      <LazyLoadWrapper>
        <div />
      </LazyLoadWrapper>
      <Box style={{ maxWidth: '1440px', margin: 'auto' }}>
        <SpacingStack spacing={[10]}>
          <Columns centered={true}>
            <ColumnWrapper width="full">
              <Box>
                <TextPairingWrapper
                  alignment="center"
                  eyebrow={eyebrow}
                  eyebrowColor="blue5"
                  eyebrowVariant="calloutHed32"
                  eyebrowTagName="h2"
                  title={ReactHtmlParser(title)}
                  titleVariant="hed96Break"
                  titleColor="blue6"
                />
                <Flex alignItems="center" justifyContent="center" paddingY={[10]}>
                  <Box marginRight={[10]}>
                    <StyledGetStartedButton id="connectedGuestListCreate" variant="secondary" page={'online-rsvp'}>
                      {getStarted}
                    </StyledGetStartedButton>
                  </Box>
                  <Box>
                    <CTALink id="connectedguestListLearnMore" aria-label="Guest List" hasChevron={true} href="/guest-list">
                      {learnMore}
                    </CTALink>
                  </Box>
                </Flex>
              </Box>
              <Box id="ConnectedGuestListAnimation">
                <StyledConnectedGuestList src={image} alt="connected guest list" />
              </Box>
            </ColumnWrapper>
          </Columns>
        </SpacingStack>
      </Box>
    </Container>
  );
};
